var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my-popup"},on:{"click":_vm.myclose}},[_c('van-loading',{attrs:{"type":"spinner","color":"#ffffff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }